module.exports = __webpack_public_path__ + "img/csi-logo.5978c86e.jpg";